/* eslint-disable indent */
import {
  AccordionSummary,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Input,
  NativeSelect,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../components/Loading';
import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { formatDateTimeToRender } from '../../../utils/functions';
import * as S from './style';

export function GroupProviderRegister() {
  const classes = S.useStyles();
  const { id } = useParams();

  const [isLoading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [frequencies, setFrequencies] = useState([]);
  const [isRegister, setIsRegister] = useState(false);
  const [getErros, setErros] = useState([]);

  const [formValues, setFormValues] = useState({
    status: 'Ativo',
    tipoPessoa: 'Juridica',
    produtorRural: 'Nao'
  });

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateProvider = async (payload) => {
    const payloadUpadte = {
      ...payload,
      grupoFornecedorId: Number(id),
      dataAtualizacao: formValues.dataAtualizacao,
    };
    try {
      const response = await api.put('GruposFornecedores', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Grupo fornecedor alterado com sucesso!');
        setFormValues(response.data.resposta);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const createProvider = async (payload) => {
    try {
      const response = await api.post('GruposFornecedores', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Grupo fornecedor criado com sucesso!');
        setFormValues({
          status: 'Ativo',
          raizCnpjCpf: '',
          tipoPessoa: 'Juridica',
          cnpjCpf: '',
          grupo: '',
          produtorRural: 'Nao',
          frequenciaAntecipacaoId: 0
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const onSubmit = async () => {
    console.log(formValues);
    const formObj = {
      ...formValues,
      dataUltimaProposta: isRegister ? null : formValues.dataUltimaProposta,
      dataUltimaAprovacao: isRegister ? null : formValues.dataUltimaAprovacao
    };
    isRegister ? createProvider(formObj) : updateProvider(formObj);
  };

  const fetchFilterOptions = async () => {
    setLoading(true);
    const freq = await api.get('FrequenciasAntecipacoes/Consultar?status=Ativo');
    setFrequencies(freq.data.resposta);
    setLoading(false);
  };

  const fetchProviderById = async (providerId) => {
    if (!providerId) return;
    setLoading(true);
    const res = await api.get(`GruposFornecedores/ConsultarId?id=${providerId}`);
    setFormValues(res.data.resposta);
    setLoading(false);
  };

  useEffect(() => {
    fetchFilterOptions();
    if (window.location.pathname.includes('cadastrar')) {
      setIsEditing(true);
      setIsRegister(true);
      return;
    }
    if (id) {
      setIsEditing(window.location.pathname.includes('editar'));
      fetchProviderById(id);
    }
  }, [id]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} grupo fornecedor ${
            isRegister ? '' : '-'
          } ${formValues?.grupo || ''}`}
          back="/app/grupo-fornecedores"
          loading={isLoading}
          submit={onSubmit}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          back="/app/grupo-fornecedores"
          loading={isLoading}
          title={`Visualizando grupo fornecedor -  ${formValues?.grupo ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>ID</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={formValues.grupoFornecedorId}
                            readOnly
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.status}
                            disabled={!isEditing}
                            name="status"
                            onChange={handleInputChange}
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                            <option value="Pendente">Pendente</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Grupo</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Grupo"
                            onChange={handleInputChange}
                            value={formValues?.grupo || ''}
                            disabled={!isEditing}
                            name="grupo"
                            error={getErros.includes('Grupo')}
                            onBlur={(event) =>
                              getErros.includes('Grupo') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Grupo';
                                }),
                              )
                            }
                            inputProps={{
                              minLength: 3,
                              maxLength: 150,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Tipo Pessoa</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.tipoPessoa}
                            disabled={!isEditing}
                            name="tipoPessoa"
                            onChange={(e) =>
                              setFormValues((val) => ({
                                ...val,
                                tipoPessoa: e.target.value,
                                cnpjCpf: '',
                                raizCnpjCpf: '',
                              }))
                            }
                            error={getErros.includes('TipoPessoa')}
                            onBlur={(event) =>
                              getErros.includes('TipoPessoa') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'TipoPessoa';
                                }),
                              )
                            }
                          >
                            <option value="Fisica">Fisica</option>
                            <option value="Juridica">Jurídica</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      {formValues?.tipoPessoa !== 'Juridica' ? (
                        <Grid item xs={6}>
                          <label className={classes.label}>CPF</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="999.999.999-99"
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              onChange={handleInputChange}
                              value={formValues?.raizCnpjCpf || ''}
                              disabled={!isEditing}
                              name="raizCnpjCpf"
                              error={getErros.includes('RaizCnpjCpf')}
                              onBlur={(event) =>
                                getErros.includes('RaizCnpjCpf') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'RaizCnpjCpf';
                                  }),
                                )
                              }
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  name="raizCnpjCpf"
                                  placeholder="CPF"
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      ) : (
                        <Grid item xs={6}>
                          <label className={classes.label}>Raiz CNPJ</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="99.999.999"
                              className={classes.input}
                              disabled={!isEditing}
                              placeholder="CNPJ"
                              value={formValues?.raizCnpjCpf || formValues?.cnpjCpf}
                              name="raizCnpjCpf"
                              onChange={handleInputChange}
                              onBlur={(event) =>
                                getErros.includes('RaizCnpjCpf') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'RaizCnpjCpf';
                                  }),
                                )
                              }
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  placeholder="CNPJ"
                                  value={formValues?.raizCnpjCpf || formValues?.cnpjCpf}
                                  name="raizCnpjCpf"
                                  error={getErros.includes('RaizCnpjCpf')}
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      )}

                      <Grid item xs={6}>
                        <label className={classes.label}>Produtor Rural</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.produtorRural}
                            disabled={!isEditing}
                            name="produtorRural"
                            onChange={(e) =>
                              setFormValues((val) => ({
                                ...val,
                                produtorRural: e.target.value,
                              }))
                            }
                            error={getErros.includes('ProdutorRural')}
                            onBlur={(event) =>
                              getErros.includes('ProdutorRural') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ProdutorRural';
                                }),
                              )
                            }
                          >
                            <option value="Nao">Não</option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Frequência Antecipação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                frequenciaAntecipacaoId: Number(e.target.value),
                              }))
                            }
                            className={classes.input}
                            disabled={!isEditing}
                            value={formValues?.frequenciaAntecipacaoId}
                            name="frequenciaAntecipacaoId"
                            error={getErros.includes('FrequenciaAntecipacaoId')}
                            onBlur={(event) =>
                              getErros.includes('FrequenciaAntecipacaoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'FrequenciaAntecipacaoId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {frequencies.map((frequency) => (
                              <option
                                key={frequency.frequenciaAntecipacaoId}
                                value={frequency.frequenciaAntecipacaoId}
                              >
                                {frequency.frequencia}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                          <label className={classes.label}>Ignorar Metas</label>
                          <Paper className={classes.medium} elevation={0}>
                            <NativeSelect
                              className={classes.input}
                              value={formValues?.ignorarMetas}
                              disabled={!isEditing}
                              name="ignorarMetas"
                              onChange={handleInputChange}
                            >
                              <option value="NaoIgnorar">Não Ignorar</option>
                              <option value="Ignorar">Ignorar</option>
                            </NativeSelect>
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Ignorar Classificados</label>
                          <Paper className={classes.medium} elevation={0}>
                            <NativeSelect
                              className={classes.input}
                              value={formValues?.ignorarClassificados}
                              disabled={!isEditing}
                              name="ignorarClassificados"
                              onChange={handleInputChange}
                            >
                              <option value="NaoIgnorar">Não Ignorar</option>
                              <option value="Ignorar">Ignorar</option>
                            </NativeSelect>
                          </Paper>
                        </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(formValues.dataAtualizacao)
                                  : ''
                              }
                              readOnly
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados das Propostas</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Proposta</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaProposta ?
                                formatDateTimeToRender(formValues.dataUltimaProposta) :
                                ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Proposta"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Aprovação</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaAprovacao
                                  ? formatDateTimeToRender(formValues.dataUltimaAprovacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Aprovação"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {(isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant="contained"
                      type="button"
                      onClick={onSubmit}
                      className={classes.button}
                    >
                      {isRegister ? 'Cadastrar' : 'Atualizar'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
